import React, { ReactNode } from 'react';
import Button from './Button';
import { FaTimes } from 'react-icons/fa';

interface ModalFormProps {
  fullScreen?: boolean;
  onClose?: () => void;
  children: ReactNode;
  halfScreen?: boolean;
}

const ModalForm: React.FC<ModalFormProps> = ({
  children,
  onClose,
  fullScreen,
  halfScreen
}) => {
  return (
    <div className="modal-overlay">
      <div
        data-testid="lightbox"
        className={`modal-content ${fullScreen ? 'full-screen' : ''} ${halfScreen ? 'half-screen' : ''}`}
      >
        {onClose && (
          <div className="modal-header">
            <Button onClick={onClose} isIcon={true} aria-label="Close">
              <FaTimes />
            </Button>
          </div>
        )}
        {children}
      </div>
    </div>
  );
};

export default ModalForm;
